export enum EditorType {
  NOTE = 'note',
  TEMPLATE = 'template',
  ASK_AI = 'ask_ai',
  DOCUMENT = 'document',
  CONTEXT = 'context',
}
